import ApplicationSerializer from './application';

export default class GroupInviteLinkSerializer extends ApplicationSerializer {
  attrs = {
    groupName: {
      serialize: false,
    },
    flowName: {
      serialize: false,
    },
    headerText: {
      serialize: false,
    },
    expectedArrivalTime: {
      serialize: false,
    },
    expiresAt: {
      serialize: false,
    },
    capacityLimit: {
      serialize: false,
    },
    remainingCapacity: {
      serialize: false,
    },
    additionalGuestsEnabled: {
      serialize: false,
    },
    active: {
      serialize: false,
    },
    ndaEnabled: {
      serialize: false,
    },
    photoEnabled: {
      serialize: false,
    },
    idScanEnabled: {
      serialize: false,
    },
    employeeScreeningFlow: {
      serialize: false,
    },
    fields: {
      serialize: false,
    },
  };
}
